import { showErrorNotification, showSuccessNotification } from 'utils/ui-toaster';
import { useCreateConnector } from 'utils/connectors';
import { ConnectorForm } from 'components/ConnectorsDashboard/components/ConnectorForm/ConnectorForm';

export const CreateConnector = () => {
  const [addConnector] = useCreateConnector();

  return (
    <ConnectorForm
      onSubmit={values => addConnector({ variables: { connector: values } })}
      action="CREATE"
    />
  );
};
